import { APIService } from '../services/index'

const initState = {
    loading: false,
    textProcess: 'In processo...',
    listaNote: [],
    listaNoteNonConfermate: [],
    listaTratte: [],
    listaAuto: [],
    listCitta: [],
    listVia: [],
    spesaDettaglio: {}
}

const pageStore = {
    state: initState,
    namespaced: true,
    getters: {
        loading(state) {
            return state.loading
        },
        textProcess(state) {
            return state.textProcess
        },
        note(state) {
            return state.listaNote
        },
        noteNonConfermate(state) {
            return state.listaNoteNonConfermate
        },
        notePerData(state) {
            return (login, data) => {
                return state.listaNote
                            .filter(ln => ln.login === login)
                            .shift()
                            .spese
                            .filter(it => it.data === data)
                            .shift()
            }
        },
        spesaDettaglio(state) {
            return state.spesaDettaglio
        },
        auto(state) {
            return state.listaAuto
        },
        autoAggiornate(state) {
            return state.listaAuto.filter(t => !Boolean(+t.flag_da_aggiornare))
        },
        autoNonAggiornate(state) {
            return state.listaAuto.filter(t => Boolean(+t.flag_da_aggiornare))
        },
        tratte(state) {
            return state.listaTratte
        },
        tratteSenzaKm(state) {
            return state.listaTratte.filter(t => !+t.km) || []
        },
        citta(state) {
            return state.listCitta
        },
        via(state) {
            return state.listVia
        },
        viaConCitta(state) {
            return state.listVia.map(v => {
                let citta = state.listCitta.filter(c => c.id == v.id_citta)[0]
                v.citta = citta ? citta.citta : null
                v.citta_eliminata = citta ? citta.eliminato : 0
                return v
            })
        },
        tratteSenzaKmConPosizione(state) {
            return state.listaTratte.map(v => {
                let pp = state.listVia.filter(c => c.id == v.id_via_p)[0]
                let pd = state.listVia.filter(c => c.id == v.id_via_d)[0]
                v.posizione_p = pp ? [pp.lat, pp.lon] : []
                v.posizione_d = pd ? [pd.lat, pd.lon] : []
                return v
            })
        },
    },
    mutations: {
        SET_LOADING(state, payload) {
            state.loading = payload.state;
            state.textProcess = payload.text || initState.textProcess;
        },
        SET_NOTE(state, payload) {
            state.listaNote = payload;
        },
        SET_SPESA_DETTAGLIO(state, payload) {
            state.spesaDettaglio = payload;
        },
        SET_NOTE_NON_CONFERMATE(state, payload) {
            state.listaNoteNonConfermate = payload;
        },
        SET_AUTO(state, payload) {
            state.listaAuto = payload;
        },
        SET_TRATTE(state, payload) {
            state.listaTratte = payload;
        },
        SET_CITTA(state, payload) {
            state.listCitta = payload;
        },
        SET_VIA(state, payload) {
            state.listVia = payload;
        },
    },
    actions: {
        getNote(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.SammGetioneGetNoteDaVerificare()
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_NOTE', res.data)
                        }
                    })
        },
        getNoteNonConfermate(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.AdminGetioneGetNoteDaVerificare()
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_NOTE_NON_CONFERMATE', res.data)
                        }
                    })
        },
        getDettaglioSpesa(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.SammGetioneGetDettaglioSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_SPESA_DETTAGLIO', res.data)
                        }
                    })
        },
        getDettaglioSpesaNonConfermata(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.AdminGetioneGetDettaglioSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_SPESA_DETTAGLIO', res.data)
                        }
                    })
        },
        getAuto(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.SammGetioneGetAutoDaVerificare()
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_AUTO', res.data)
                        }
                    })
        },
        getTratte(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.SammGetioneGetTratteDaVerificare()
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.commit('SET_TRATTE', res.data)
                        }
                    })
        },
        getAllCitta(context, data) {
            return APIService.trattaGetAllCitta()
                    .then(function (res) {
                        if (res.stato === 'success') {
                            context.commit('SET_CITTA', res.data);
                        }
                    })
        },
        getAllVia(context, data) {
            return APIService.trattaGetAllVia()
                    .then(function (res) {
                        if (res.stato === 'success') {
                            context.commit('SET_VIA', res.data);
                        }
                    })
        },
        getAutoLibterro(context, data) {
            context.commit('SET_LOADING', {state: true, text: 'Estrazione libretto...'});
            return APIService.SammGetAutoLibterro(data)
            .finally(() => {
                context.commit('SET_LOADING', {state: false});
            })
        },
        newTratta(context, data) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Inserimento nuova tratta...'});
            return APIService.trattaNew(data)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                        if (res.stato === 'success') {
                            context.dispatch('getTratte');
                            return true
                        }
                        return false
                    })
        },
        changeTrattaItem(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.SammGetioneChangeTrattaItem(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.dispatch('getTratte')
                            context.dispatch('getAllCitta');
                            context.dispatch('getAllVia');
                        }
                    })
        },
        toggleTrattaItem(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            APIService.SammGetioneToggleTrattaItem(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.dispatch('getTratte')
                            context.dispatch('getAllCitta');
                            context.dispatch('getAllVia');
                        }
                    })
        },
        setCoefficiente(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Change coefficiente...'});
            return APIService.SammGestioneSetCoefficiente(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.dispatch('getAuto');
                            return true
                        }
                        return false
                    })
        },
        confirmNota(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Processing...'});
            return APIService.SammGestioneConfirmNotaSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.dispatch('getNote');
                            return true
                        }
                        return false
                    })
        },
        updateAuto(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Modificazione...'});
            return APIService.SammGestioneUpdateAuto({ data: params })
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.stato === 'success') {
                            context.dispatch('getAuto');
                            return true
                        }
                        return false
                    })
        },
        inviaSpesa(context, params) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Sta inviando ...'});
            return APIService.SammGetioneInviaSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        context.dispatch('getNote');
                        context.dispatch('getNoteNonConfermate');
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                    })
        },
        newTarga(context, data) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Inserimento nuova targa...'});
            return APIService.targaNew(data)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                        if (res.stato === 'success') {
                            context.dispatch('getAuto');
                            return true
                        }
                        return false
                    })
        },
        removeLoginPrivato(context, data) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            return APIService.removeLoginPrivato(data)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                        if (res.stato === 'success') {
                            context.dispatch('getAuto');
                            return true
                        }
                        return false
                    }).catch(() => context.commit('SET_LOADING', {state: false}))
        },
        addLoginPrivato(context, data) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'In processo...'});
            return APIService.addLoginPrivato(data)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        $that.$notify({
                            group: res.stato,
                            text: res.textError
                          });
                        if (res.stato === 'success') {
                            context.dispatch('getAuto');
                            return true
                        }
                        return false
                    }).catch(() => context.commit('SET_LOADING', {state: false}))
        },
        searchPlace(context, data) {
            const at = '38.0942119,15.65065'
            const q = data
            const app_id = 'eLB4jmsueNDd1At2iSdC'
            const app_code = 'plyNFw9vdDhpK3Ss74f8Ug'
            
            return APIService.hereGetPlace({ at, app_id, app_code, q })
        },
        searchDistance(context, data) {
            const at = '38.0942119,15.65065'
            const app_id = 'eLB4jmsueNDd1At2iSdC'
            const app_code = 'plyNFw9vdDhpK3Ss74f8Ug'
            const mode= 'fastest;car;traffic:disabled'
            let waypoint0 = data.da, waypoint1 = data.a
            
            return APIService.hereGetDistance({ app_id, app_code, waypoint0, waypoint1, mode })
        },
        async syncTratta(context, data) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Sincronizazione...'});
            const at = '38.0942119,15.65065'
            const q = ''
            const app_id = 'eLB4jmsueNDd1At2iSdC'
            const app_code = 'plyNFw9vdDhpK3Ss74f8Ug'
            const mode= 'fastest;car;traffic:disabled'
            let waypoint0, waypoint1 = ''
            
            for (var tr in context.getters.tratteSenzaKmConPosizione) {
                
                if (context.getters.tratteSenzaKmConPosizione[tr].km) continue;
                
                let pp = context.getters.tratteSenzaKmConPosizione[tr].posizione_p
                let pd = context.getters.tratteSenzaKmConPosizione[tr].posizione_d
                
                if (!pp || !pd) continue;
                
                let w0 = pp
                let w1 = pd
                
                if (!w0 || !w1) continue;
                
                waypoint0 = 'geo!' + w0.join(',')
                waypoint1 = 'geo!' + w1.join(',')
                
                await APIService.hereGetDistance({ app_id, app_code, waypoint0, waypoint1, mode })
                .then(async function (res) {
                    if (200 === res.status && res.ok && res.data.response) {
                        let distance = res.data.response.route.map(r => (r.summary.distance / 1000).toFixed(0)).join(';')
                        await APIService.SammGetioneChangeTrattaItem({
                            tipo: 'KM',
                            id: context.getters.tratteSenzaKmConPosizione[tr].id,
                            valore: distance
                          })
                    }
                })
            }
            
            await context.dispatch('getTratte')
            
            context.commit('SET_LOADING', {state: false});
            
        },
    }
};

export default pageStore;


// WEBPACK FOOTER //
// ./modules/Home/views/src/stores/gestioneSamm.js